<style scoped>
    li a:hover{
       background: none;
    }
</style>
<template>
    <div class="navbar navbar-fixed-top" role="navigation">
        <div class="navbar-header">
            <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-collapse">
                <span class="sr-only">Toggle navigation</span>
            </button>
            <a class="navbar-brand" href="#">
                <img src="../img/shoplogo.png" class="mt-16">
            </a>
        </div>
        <div class="navbar-collapse collapse">
            <ul class="nav navbar-nav navbar-right">
                <li class="cfff mt17 ml10"> 你好！{{account.name}}</li>
                <li class="mt17 ml10">
                    <img src="../img/duty.png" class="ml5 f20 mt-2" v-if="account.duty" width="18"/> <span class="ml5">{{account.duty}}</span>
                    <img src="../img/company.png" class="ml5 f20 mt-5" width="22" /> <span class="ml5">路易公司</span>
                </li>
                <li><a href="javascript:;" @click="submit" class="cfff"><span class="glyphicon glyphicon-log-out f20"></span></a></li>
            </ul>
        </div>
    </div>
</template>
<script>
    var Http = require('../utils/HttpHelper.js');
    var Comm = require('../utils/Common.js');
    module.exports= {
        data : function(){
            return {
                account: {},//账户信息
            }
        },
        ready: function() {
            var self = this;
            Http["account"].query({
                succ: function(rs) {
                    self.account = rs;
                },
                err: function(msg) {
                    Comm.tipDialog(msg, 1500, "error");
                }
            })
        },
        methods : {
            submit : function(){
                var self = this;
                Http.logout.create({
                    succ : function(){     
                        //派发事件，事件沿着父链冒泡；
                        self.$dispatch('loginOut');
                    },
                    err : function(rs){
                        Comm.tipDialog(rs,1500,"error");
                    }
                });
            }
        }
    }
</script>


/** WEBPACK FOOTER **
 ** Header.vue?2dbd4a90
 **/